import { IStateSession } from '@libs/types';

const EMBEDDED_PLAYER_SESSIONS = 'embeddedPlayerSessions';
const IS_SUPPORT_MULTI_TABS = Boolean(process.env.NX_PUBLIC_SUPPORT_MULTI_TABS ?? false);

interface EmbeddedPlayerSession {
    auth?: IStateSession['auth'];
    isFillParent?: boolean;
}

interface EmbeddedPlayerSessions {
    [playerId: string]: EmbeddedPlayerSession;
}

const getEmbeddedPlayerSessions = (fromLocalStorage = false): EmbeddedPlayerSessions => {
    const sessions = (IS_SUPPORT_MULTI_TABS ? (fromLocalStorage ? localStorage : sessionStorage) : localStorage)?.getItem(EMBEDDED_PLAYER_SESSIONS);
    return sessions ? JSON.parse(sessions) : {};
};

const setEmbeddedPlayerSessions = (newSessions: EmbeddedPlayerSessions): void => {
    if (IS_SUPPORT_MULTI_TABS) {
        sessionStorage?.setItem(EMBEDDED_PLAYER_SESSIONS, JSON.stringify(newSessions));
    }
    const oldLSSessions = getEmbeddedPlayerSessions(true);
    localStorage?.setItem(EMBEDDED_PLAYER_SESSIONS, JSON.stringify({ ...oldLSSessions, ...newSessions }));
};

export const getEmbeddedPlayerSession = (playerId: string, isRequestInteraction = false): EmbeddedPlayerSession | undefined => {
    const sessionSS = getEmbeddedPlayerSessions()[playerId];
    const sessionLS = getEmbeddedPlayerSessions(true)[playerId];

    if (sessionSS) {
        return sessionSS;
    } else if (sessionLS && isRequestInteraction) {
        return { ...sessionLS, isFillParent: true };
    }
    return undefined;
};

export const setEmbeddedPlayerSession = (playerId: string, session: EmbeddedPlayerSession): void => {
    const sessions = getEmbeddedPlayerSessions();
    sessions[playerId] = session;
    setEmbeddedPlayerSessions(sessions);
};

export const clearEmbeddedPlayerSession = (playerId: string): void => {
    const sessions = getEmbeddedPlayerSessions();
    delete sessions[playerId];
    setEmbeddedPlayerSessions(sessions);
};
